export default theme => ({
  root: {
    position: 'relative',
    width: '100%',
    height: '100%',
    '&, & *': {
      boxSizing: 'border-box'
    },
    '@media screen and (max-width: 850px)': {
      '& $pic': {
        flexBasis: 100
      },
      '& $footer': {
        flexDirection: 'column',
        gap: 16
      }
    }
  },
  bg: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 0,
    width: '100%',
    height: '100%',
    '& > img': {
      display: 'block',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'left top'
    }
  },
  container: {
    position: 'absolute',
    bottom: 50,
    left: 50,
    zIndex: 1,
    width: 900,
    maxWidth: 'calc(100% - 100px)',
    padding: '32px 32px 32px 24px',
    background: `linear-gradient(to right, ${theme.colors.primary.white} 27%, ${theme.colors.grey[100]} 72%)`,
    borderRadius: 16,
    boxShadow: '0px 12px 17px rgba(39, 60, 80, 0.14), 0px 5px 22px rgba(39, 60, 80, 0.12), 0px 7px 8px rgba(39, 60, 80, 0.2)',
    display: 'flex',
    flexFlow: 'row nowrap',
    gap: 32,
    justifyContent: 'center'
  },
  pic: {
    flex: '0 0 176px',
    display: 'flex',
    '& > svg': {
      display: 'block',
      width: '100%',
      height: 'auto',
      aspectRatio: 1.16
    }
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    flex: 1
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20
  },
  footer: {
    display: 'flex',
    flexDirection: 'row nowrap',
    gap: 40,
    justifyContent: 'flex-end'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '& strong': {
      color: theme.colors.utility.textPrimary
    }
  }
});